"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _Table = require("./Table");

var _Checkbox = _interopRequireDefault(require("@insided/shared/uikit/Checkbox"));

var _DragHandle = _interopRequireDefault(require("@insided/deprecated-preact-components/control/DragHandle"));

var _classnames = _interopRequireDefault(require("classnames"));

var Row = function Row(_ref) {
  var id = _ref.id,
      cells = _ref.cells,
      model = _ref.model,
      _ref$displayFirstColu = _ref.displayFirstColumnBold,
      displayFirstColumnBold = _ref$displayFirstColu === void 0 ? false : _ref$displayFirstColu,
      isSelectable = _ref.isSelectable,
      onSelectRow = _ref.onSelectRow,
      isSelected = _ref.isSelected,
      _ref$dragDropFunction = _ref.dragDropFunctionality,
      dragDropFunctionality = _ref$dragDropFunction === void 0 ? false : _ref$dragDropFunction;
  return (0, _preact.h)("tr", {
    id: id ? cells[id] : null,
    className: (0, _classnames.default)({
      'control-table__row--selected': isSelected,
      'control-table__row--draggable': dragDropFunctionality
    })
  }, isSelectable && (0, _preact.h)("th", {
    className: "table-header--multiselect",
    scope: "row"
  }, (0, _preact.h)(_Checkbox.default, {
    qaClasses: "row-".concat(id && cells[id]),
    onUpdate: function onUpdate() {
      return id && onSelectRow && onSelectRow(cells[id], !isSelected);
    },
    checked: !!isSelected
  })), dragDropFunctionality && (0, _preact.h)("th", {
    className: "table-header--drag",
    scope: "row"
  }, (0, _preact.h)(_DragHandle.default, null)), model ? Object.keys(model).map(function (key) {
    if (model[key].isHidden) {
      return null;
    }

    var _model$key = model[key],
        accessor = _model$key.accessor,
        customCell = _model$key.cell,
        size = _model$key.size;

    if (displayFirstColumnBold && key === '0') {
      return (0, _preact.h)("th", {
        scope: "row",
        className: "qa-".concat(accessor, " ").concat(size !== null && size !== void 0 ? size : _Table.defaultCellSize)
      }, ' ', customCell ? customCell(cells) : accessor && cells[accessor]);
    }

    return (0, _preact.h)("td", {
      key: key,
      className: "qa-".concat(accessor, " ").concat(size !== null && size !== void 0 ? size : _Table.defaultCellSize)
    }, customCell ? customCell(cells) : accessor && cells[accessor]);
  }) : Object.keys(cells).map(function (key) {
    if (displayFirstColumnBold && key === '0' && !cells[key].colspan && cells[key].accessor !== 'tag-selector') {
      return (0, _preact.h)("th", {
        key: key,
        scope: "row",
        className: "qa-".concat(Object.prototype.hasOwnProperty.call(cells[key], 'accessor') ? cells[key].accessor : key, " ").concat(cells[key].size || _Table.defaultCellSize)
      }, Object.prototype.hasOwnProperty.call(cells[key], 'cell') ? cells[key].cell : cells[key]);
    }

    return (0, _preact.h)("td", {
      key: key,
      colSpan: Object.prototype.hasOwnProperty.call(cells[key], 'colspan') ? cells[key].colspan : undefined,
      className: "qa-".concat(Object.prototype.hasOwnProperty.call(cells[key], 'accessor') ? cells[key].accessor : key, " ").concat(cells[key].size || _Table.defaultCellSize)
    }, Object.prototype.hasOwnProperty.call(cells[key], 'cell') ? cells[key].cell : cells[key]);
  }));
};

var _default = Row;
exports.default = _default;